import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'

class SearchService {
  searchWithIntent(query, intentParams, urlContext = "", shortResults = true, maxCount = 50) {
    // Create simple JSON object
    const requestBody = {
      query: query || "",
      urlContext: urlContext || "",
      shortResults: shortResults,
      format: "",
      maxCount: maxCount,
      intentParams: intentParams || {}
    };
    
    // Debug: Log what we're sending
    console.log("SearchService - Sending request body:", requestBody);
    console.log("SearchService - Query value:", query);
    console.log("SearchService - Query type:", typeof query);
    
    // Send as JSON
    return TCVelikClient.PostRelative(`/api/SearchWithIntent`, requestBody);
  }

  search(query, urlContext = "", shortResults = true, maxCount = 50) {
    // Encode the URL context using base64
    const encodedUrlContext = urlContext ? btoa(encodeURIComponent(urlContext)) : '';
    return TCVelikClient.GetRelative(`/api/search?query=${encodeURIComponent(query)}&urlContext=${encodedUrlContext}&shortResults=${shortResults}&maxCount=${maxCount}`);
  }

  getIntentFilters() {
    return {
      System: [],
      Client: [],
      Project: [],
      Role: [],
      ActionType: [],
      LifecycleStage: [],
      Technology: [],
      Environment: [],
      Persona: [],
      Frequency: [],
      SensitivityLevel: []
    };
  }

  getIntentValues() {
    return TCVelikClient.GetRelative("/api/intentvalues");
  }

  getExistingIntents() {
    return TCVelikClient.GetRelative("/api/existingintents");
  }
}

export default new SearchService(); 